// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-particle-line[data-v-88a02d56] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 0;\n}\n.vue-particle-line .slot-wraper[data-v-88a02d56] {\n  z-index: 1;\n}\n.vue-particle-line .canvas[data-v-88a02d56] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
